/**
 * Plays a beep sound using the Web Audio API
 * @param {number} duration - Duration of the beep in milliseconds (default: 1000ms)
 * @param {number} frequency - Frequency of the beep in Hz (default: 800Hz)
 */
export const playBeep = (duration = 1000, frequency = 800) => {
  try {
    // Create audio context
    const AudioContext = window.AudioContext || window.webkitAudioContext;
    const audioContext = new AudioContext();
    
    // Create oscillator and gain node
    const oscillator = audioContext.createOscillator();
    const gainNode = audioContext.createGain();
    
    // Connect nodes
    oscillator.connect(gainNode);
    gainNode.connect(audioContext.destination);
    
    // Set oscillator type and frequency
    oscillator.type = 'sine';
    oscillator.frequency.value = frequency;
    
    // Set gain (volume) to 0.3 (30%)
    gainNode.gain.value = 0.3;
    
    // Start the oscillator
    oscillator.start();
    
    // Stop the oscillator after the specified duration
    setTimeout(() => {
      oscillator.stop();
    }, duration);
  } catch (error) {
    console.warn('Could not play beep sound:', error);
  }
};

export default playBeep;